import Page from '../../../components/PageWrapper';
import { Outlet } from 'react-router-dom';

function LoanProductsOutlet() {

  return (
    <Page title="Loan Products">
      <Outlet />
    </Page>
  );
}

export default LoanProductsOutlet;
